// extracted by mini-css-extract-plugin
module.exports = {"attention":"ConnectionDropdown_attention__1hhgt"};